export default {
  namespaced: true,
  inventory: {
    title: "Inventário",
    new: "Novo inventário",
    edit: "Editar inventário",
    error_title: "Existem erros no arquivo:",
    fields: {
      region: "Região",
      municipality: "Município",
      rems: "REMS",
      sirh: "SIRH",
      unit: "Unidade",
      unit_name: "Nome da unidade",
      unit_type: "Tipo de unidade",
      equipment_type: "Tipo de equipamento",
      brand: "Marca",
      model: "Modelo",
      status: "Status",
      installation_date: "Data de instalação",
      depreciation_start_date: "Data de início da depreciação",
      useful_life_months: "Vida útil (meses)",
      remaining_life_months: "Vida útil restante (meses)",
      project: "Projeto",
      project_id: "ID do projeto",
      project_name: "Nome do projeto",
      division: "Divisão",
      municipality: "Município",
      unit_category: "Categoria da unidade",
      unit_name: "Nome da unidade",
      equipment_type: "Tipo de equipamento",
      serial_number: "Número de série",
      fixed_asset_number: "Número do ativo imobilizado",
      equipment_cost: "Custo do equipamento",
      accumulated_depreciation: "Depreciação acumulada",
      project: "Projeto",
      name: "Nome",
      updated_at: "Atualizado em",
      created_at: "Criado em",
    },
    actions: {
      cancel: "Cancelar",
      save: "Salvar",
    },
    status: {
      installed: "Instalado",
      new_custody: "Nova custódia",
      paused: "Pausado",
    },
    catalogs: {
      brands: "Catálogo de marcas",
      projects: "Catálogo de projetos",
      equipmentTypes: "Catálogo de tipos de equipamento",
    },
  },
};
